import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import Reveal from '../../components/Reveal';
import { WHATSAPP } from './constants';

export default function CtaBanner() {
  const { t } = useTranslation();

  return (
    <section className="py-16 px-6">
      <Reveal className="max-w-5xl mx-auto">
        <div className="relative overflow-hidden bg-gradient-to-br from-violet-500 to-indigo-600 rounded-3xl px-8 py-14 text-center">
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-2xl pointer-events-none" />
          <div className="absolute -bottom-12 -left-12 w-48 h-48 bg-indigo-400/20 rounded-full blur-2xl pointer-events-none" />
          <div className="relative z-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-white">{t('landing.cta.title')}</h2>
            <p className="text-violet-100 text-sm sm:text-base mt-3 mb-8 max-w-xl mx-auto">{t('landing.cta.subtitle')}</p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <a
                href={WHATSAPP}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 bg-white text-violet-600 font-semibold text-sm px-6 py-3 rounded-xl hover:bg-violet-50 hover:scale-105 transition-all"
              >
                {t('landing.cta.primaryBtn')}
                <ArrowRight size={16} />
              </a>
              <a
                href={WHATSAPP}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 bg-white/10 text-white font-semibold text-sm px-6 py-3 rounded-xl border border-white/30 hover:bg-white/20 transition-colors"
              >
                {t('landing.cta.secondaryBtn')}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
